<template>
        <div id="wxGuidePop" ref="downloadPop" class="wxGuidePop downloadAppPop" v-show="wxpopShow" :class="{'oConfirmPop':isBrowser}">
            <div class="share_close fl wxGuideClose" id="closeDownloadApp" @click="closeWxGuide"></div>
            <div class="wxGuideBox oConfirmPop" id="wxGuideBox" v-html="msg" v-if="isBrowser">
        </div>
        <div class="wxGuideBox" id="wxGuideBox" v-else>
            <div class="bg_share">
                <div class="w1575">
                    <div class="wxGuide">
                        <section class="share_top fix">
                            <div class="share_center"><p>已经安装<strong>拍卖图录App</strong></p>
                                <p>点击右上角...</p>
                                <p>选择<span>浏览器</span>中打开</p>
                            </div>
                            <div class="s_right fr"></div>
                        </section>
                        <section class="iphone">
                            <div class="iphone_text">
                                <p>未安装<span>雅昌拍卖图录</span></p>
                            </div>
                            <div class="logo_img"><img src="../../../assets/img/share/tulu_logo.png" alt="拍卖图录"></div>
                            <a class="download" id="wxGuideBtn" href="https://app.artron.net/tuluApk/tulu_artron.apk">立即下载</a>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {isWeixin,isGreaterThan9,lower,isAndroid,isChrome} from "@/api/auction/isWeixin";
export default {
    name: "downloadApp",
    data(){
        return{
            addDownload:false,
            wxpopShow:false,
            downloadAppLink:'',
            isBrowser:false,
            msg:''
        }
    },
    mounted() {
        // this.getAppSource()
    },
    methods:{
        gotoAppDownload(url,spread){
            let that=this
            if (isWeixin()){
                var wechatInfo = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i);
                if(lower(wechatInfo[1],'7.0.5')||isAndroid()){
                    var urlLink = url;
                    var spreadID = spread;
                    var transUrl =  spreadID ? "http://tulu.artron.net/wap/share/download?urlLink=" + encodeURIComponent(urlLink + "&spread=")  + spreadID : "http://tulu.artron.net/wap/share/download?urlLink=" + encodeURIComponent(urlLink);
                    var  androidDownload = 'https://app.artron.net/tuluApk/tulu_artron.apk';
                    if(isAndroid){
                        this.downloadAppLink = androidDownload;
                        this.wxpopShow = true;

                    }else {
                        window.location.href = transUrl;
                    }
                }else {
                    goToApp(url,spread);
                }
            }else {
                goToApp(url,spread);
            }
            function goToApp(url,spread) {
                var urlLink = url;
                var spreadID = spread;
                var universUrl,schemeUrl,androidDownload;
                universUrl = spreadID ? "https://linkapps.artron.net" + urlLink + "?spread=" + spreadID : "https://linkapps.artron.net" + urlLink;
                androidDownload = 'https://app.artron.net/tuluApk/tulu_artron.apk';
                schemeUrl = 'artrontulu://linkapps.artron.net' + urlLink;
                // iosDownload = spreadID ? androidDownload : "https://apps.apple.com/cn/app/id542306732";
                if(isGreaterThan9()){
                    //判断是否为ios9以上的版本,跟其他判断一样navigator.userAgent判断,ios会有带版本号
                    window.location.href = universUrl;
                }else {
                    if(isAndroid()){
                        if(isChrome()){
                            window.location = schemeUrl;
                        }else {
                            var ifr=document.createElement('iframe');
                            ifr.src=schemeUrl;
                            ifr.style.display="none";
                            document.body.appendChild(ifr);
                        }
                    }else {
                        window.location = schemeUrl;
                    }
                    var timer = setTimeout(function () {
                        that.wxpopShow = true;
                        that.isBrowser = true;
                        that.msg = '<div class="installConfirm"><img src="https://tulu.artron.net/resource/share/imgs/tulu_logo.png" alt="拍卖图录"/><p>雅昌拍卖图录</p><a href="'+ androidDownload +'">安装</a></div>';
                        clearTimeout(timer);
                        var timer2 = setTimeout(function () {
                            that.wxpopShow = false;
                            that.isBrowser = false;
                            clearTimeout(timer2);
                        },5000);
                    },3000);
                }
            }
        },
        closeWxGuide(){
            this.wxpopShow = false
        },
    }
}
</script>

<style scoped>
@import url("../../../assets/css/downloadAppPop.css");
</style>